export default __webpack_public_path__ + "static/media/delete_icon.72244cb6.svg";